import variables from './cssInJs/variables';

const cssEmotion = {
  breakpointNames: variables.breakpointNames,
  breakpoints: variables.breakpoints
}

// Firebase configuration for push notifications
// TODO: Replace with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIAqN_OEjjNYKgYcRxWoDsbG1jv9xOtpE",
  authDomain: "adelaidefooty-dd4eb.firebaseapp.com", 
  projectId: "adelaidefooty-dd4eb",
  storageBucket: "adelaidefooty-dd4eb.appspot.com",
  messagingSenderId: "155304670865",
  appId: "1:155304670865:web:9b3004b31ee0fcf498b130"
};

export default {
  cssEmotion,
  firebaseConfig,
  firebaseSettings: firebaseConfig
}